export default "__VITE_ASSET__BQ7sZXKi__"